<template>
    <div>
        <el-dialog
            title="缴费信息"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :show-close="false"
            width="1000px"
            class="pay_class"
            >
                <div style="padding: 0  0 20px 20px;font-size: 18px;">
                    <p>姓名：{{ userInfo.studentName }}</p>
                    <p v-if="payStatusInfo.payType == 1">待缴费：<span style="color:red">￥ {{ toBePaid }}</span></p>
                    <template v-if="!$strExistHostnameOnce(['hsnc'])">
                        <p>身份证号：{{ userInfo.studentIdCard || "-" }}</p>
                    </template>
                    <template v-else>
                        <p>学号：{{ userInfo.studentNo || "-" }}</p>
                    </template>

                    <el-button type="primary" v-if="payStatusInfo.payType == 1" @click="payDialogClick">去支付</el-button>
                    <el-row style="color: red;">
                        {{ payStatusInfo.payMsg }}
                    </el-row>
                </div>
        </el-dialog>

        <el-dialog :title="pay_dialog.title" :visible.sync="pay_dialog.visible" class="payDialog" width="600px">
            <div style="font-size: 18px;">
                <el-row>
                    <el-col>
                        <span class="spanTitle">支付金额</span>
                        <span class="money">￥{{ toBePaid }}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <span class="spanTitle">支付订单号</span>
                        <span>{{ payId }}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <div class="typeBox">
                            <span class="spanTitle">支付方式</span>
                            <img src="../assets/wechat.png" alt="" :class="pay_dialog.payType == 'wechat' ? 'selected' : ''"
                                @click="changePayType('wechat')">
                            <!-- <img src="../assets/alipay.png" alt="" :class="pay_dialog.payType == 'alipay' ? 'selected' : ''"
                                @click="changePayType('alipay')"> -->
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="pay_dialog.visible = false">关 闭</el-button>
                <el-button type="primary" @click="goPay">立即支付</el-button>
            </div>
        </el-dialog>

        <el-dialog width="600px" :visible.sync="pay_dialog.inner_dialog.visible" append-to-body @close="closePay_dialog" class="payInnerDialog">
            <div slot="title" class="dialog-title" style="display: flex;align-items: center">
                <img :src="pay_dialog.payType === 'wechat' ? require('../assets/wechat.png') : require('../assets/alipay.png')"
                    alt="">
                <span style="margin-left: 1em">{{ pay_dialog.inner_dialog.title }}</span>
            </div>
            <div v-if="pay_dialog.payType === 'wechat'" id="qrcode" ref="qrcode"
                style="border: none;height: 147px;line-height: 147px;width: 147px;margin: 0 auto;text-align: center;">
                <i class="el-icon-loading" style="font-size: 30px;"></i></div>
            <iframe v-else :src="pay_dialog.inner_dialog.imgSrc" width="200px" height="210px"
                style="border: none;"></iframe>
            <p class="tip" style="color:red;text-align: center;padding-bottom: 20px;">请扫码支付 ￥{{ toBePaid }}</p>
        </el-dialog>
    </div>
</template>
<script>
    import QRCode from 'qrcodejs2';
    import {
        getOnlinePrice,
        downloadPayList,
        getWeChatPayQRCode_studnt,
        getAliPayQRCode,
        createPayId,
        getPayList
    } from "../common/services";
export default {
    name: 'newIndex',
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            userInfo: {},
            toBePaid:0, //缴费金额
            payStatusInfo: {
                payStatus: "",  //1已缴费  2未交费
                payMsg: ""    //如果是1已缴费的时候，你可以显示这里面的消息到缴费页面
            },
            // 支付
            pay_dialog: {
                visible: false,
                title: "选择支付方式",
                payType: "wechat",
                inner_dialog: {
                    imgSrc: "",
                    visible: false,
                    title: "微信支付",
                }
            },
            payId: "",//支付订单号
            payStatusTimeout: null,
        }
    },
    created() {
        this.getPayAmount();
        const studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())); //获取学生信息
        this.userInfo = studentInfo;
    },
    methods:{
        getPayAmount() { //获取缴费金额
            this.$store.dispatch("user/getPayAmount").then((ret) => {
                if(ret.code == 0 && ret.data != null && ret.data != "" && ret.data > 0){ //金额大于0
                    this.toBePaid = ret.data;
                    this.$store.dispatch("user/getStudentStatusPayInfo").then((rets) => { //查询是否已经付费
                        if(rets.data != null && rets.data.payStatus == 2){ //payStatus交易状态（1已缴费、2未缴费）
                            this.payStatusInfo = rets.data;
                            //弹出缴费窗体
                            this.dialogVisible = true;
                        }
                    }).catch(() => {

                    });
                }
            }).catch(() => {

            });
        },
        payDialogClick(){ //去支付
            this.pay_dialog.visible = true;
            //在籍学生创建订单，获取订单outTradeNo
            this.getCreatStudentStatusOrder();
        },
        changePayType(type = 'wechat') {
            this.pay_dialog.payType = type;
            this.pay_dialog.inner_dialog.imgSrc = "";
        },
        getWeChatQrcode(text) {
            this.$refs.qrcode.innerHTML = "";
            return new QRCode('qrcode', {
                width: 147, // 设置宽度，单位像素
                height: 147, // 设置高度，单位像素
                text,   // 设置二维码内容或跳转地址
            })

        },
        async goPay() {
            const originDialog = this.pay_dialog;
            const originInnerDialog = originDialog.inner_dialog;
            const payType = originDialog.payType;
            this.pay_dialog.inner_dialog = {
                ...originInnerDialog,
                visible: true,
                title: payType === 'wechat' ? '微信支付' : '支付宝支付'
            }
            const imgPath = await this.getPayQRCode(payType);
            // console.log('获取到的图片地址', imgPath);
            this.pay_dialog.inner_dialog.imgSrc = imgPath;
        },
        async getPayQRCode(type = 'wechat') {
            this.payStatusTimeout = setInterval(() => { //轮训获取支付状态。
                this.getPayStatusTimeout();
            }, 3500);
            //支付宝直接获取地址展示，微信获取到之后要将文本转成二维码
            // const fn = type === 'wechat' ? getWeChatPayQRCode_studnt : getAliPayQRCode;
            const fn = getWeChatPayQRCode_studnt;
            const res = await fn(this.payId);
            //区分微信、支付宝
            if (type == 'wechat') {
                const imgPath = this.getWeChatQrcode(res.data);
                // console.log(imgPath)
                return "";
            } else {
                return res.data;
            }
        },
        getCreatStudentStatusOrder() { //在籍学生创建订单，获取订单outTradeNo
            this.$store.dispatch("user/creatStudentStatusOrder").then((ret) => {
                if (ret.code == 0) {
                    this.payId = ret.data;
                }
            }).catch(() => {

            });
        },
        getPayStatusTimeout() { //用于轮训查询缴费状态
            this.$store.dispatch("user/getStudentStatusPayInfo").then((ret) => {
                if (ret.code == 0) {
                    this.payStatusInfo = ret.data;

                    if (this.payStatusInfo.payStatus == 1 && this.payStatusTimeout != null) { //1已缴费  2未交费
                        clearInterval(this.payStatusTimeout);
                        this.$message({
                            message: ret.data.payMsg,
                            type: 'success',
                            duration:2000,
                            onClose: () => {
                                this.dialogVisible = false;
                                this.pay_dialog.inner_dialog.visible = false;
                                this.pay_dialog.visible = false;
                            }
                        });

                    }
                }
            }).catch(() => {

            });
        },
        closePay_dialog(){
            if(this.payStatusTimeout != null){
                clearInterval(this.payStatusTimeout);
            }
        }
    }
};
</script>
<style lang="less">
    .pay_class{
        img{
            max-width: 100%;
            height: auto;
            cursor: pointer;
        }
        h2{
            p{
                margin-top: 0;
                margin-top: 0;
            }
        }
    }
    .payDialog {
        .spanTitle {
            display: inline-block;
            width: 100px;
            text-align: right;
        }

        .el-col {
            line-height: 2em;

            span {
                &.money {
                    color: red;
                }

                &:nth-child(2) {
                    margin-left: 2em;
                }
            }

            .typeBox {
                span {
                    line-height: 50px;
                    vertical-align: top;
                    display: inline-block;
                }

                img {
                    margin-left: 2em;
                    padding: 10px;
                    border: 1px solid transparent;

                    &.selected {
                        border-color: lightgrey;
                        box-shadow: 0 0 1px grey inset;
                        border-radius: 10px;
                    }

                }
            }

        }

        p.tip {
            margin-bottom: 3em;
        }

        .payInnerDialog {}
    }
</style>



// WEBPACK FOOTER //
// src/components/studentPay.vue